import { ArrowTopRightOnSquareIcon, WindowIcon } from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import Image from "src/components/elements/Image";
import MenuItemTextHighlighter from "src/components/navigation/MenuItemTextHighlighter";
import { isSVGString } from "src/helpers";
import { classNames } from "src/helpers/classNames";

const LeftMenuItemLink = ({ data, page_id, group_id, searchTerm, isTopLevel = false, image = null, imageClassName = "", setImageClassName = () => {}, buttonClasses, handleMenuClick = () => {}, isCollapsed }) => {
  const tooltipId = `left-menu-tooltip-${data._id || data.slug || data.name?.replace(/\s+/g, '-')}`;

  return (
    <>
      <div className={classNames("relative select-none", data.type !== "internal" ? "group/link" : "")}>
        {data.type === "internal" ? (
          <Link
            to={data.link}
            onClick={handleMenuClick}
            data-tooltip-id={isCollapsed ? tooltipId : undefined}
            data-tooltip-content={isCollapsed ? data.name : undefined}
            data-tooltip-place="right"
            className={classNames(
              "flex min-h-10 w-full items-center rounded py-2 transition-all",
              isCollapsed ? "justify-center px-1" : "justify-between px-3",
              isTopLevel ? "" : "hover:bg-leftNavActiveColor hover:text-leftNavActiveTextColor",
              buttonClasses,
              (
                data.sub
                  ? (data._id === page_id || data.slug === page_id) && data.groupId === group_id
                  : ((data._id === page_id || data.slug === page_id) && !data.groupId && !group_id) || (data.groupId && group_id && data.groupId === group_id && (data._id === page_id || data.slug === page_id))
              )
                ? "!bg-leftNavActiveColor text-leftNavActiveTextColor"
                : "text-leftNavTextColor",
            )}>
            <div className={classNames("group flex min-w-0 items-center", isCollapsed ? "flex-initial justify-center" : "flex-1")}>
              {(image || isCollapsed) && (
                <div
                  className={classNames(
                    "nav-icon flex flex-shrink-0 items-center justify-center [&_svg]:h-full [&_svg]:w-full",
                    isCollapsed ? "mr-0 h-6 w-6" : "mr-2 h-5 w-5",
                    isSVGString(image) ? "" : "flex items-center justify-center",
                    isTopLevel ? "opacity-80 group-hover:opacity-100" : "",
                    imageClassName,
                  )}>
                  {image ? (
                    isSVGString(image) ? (
                      <div
                        className="h-full w-full"
                        dangerouslySetInnerHTML={{ __html: image.replace(/stroke-width="[^"]*"/g, 'stroke-width="1.7"') }}
                      />
                    ) : (
                      <Image
                        src={image}
                        alt={"Menu image"}
                        classes={classNames(imageClassName, "h-full w-full object-contain")}
                        onError={() => setImageClassName("hidden")}
                      />
                    )
                  ) : (
                    <WindowIcon className="h-6 w-6 stroke-[1.7]" />
                  )}
                </div>
              )}
              {!isCollapsed && (
                <span
                  className={classNames("min-w-0 flex-1 break-words text-base leading-tight", isTopLevel ? "font-normal opacity-80 group-hover:opacity-100" : "font-medium")}
                  title={data.name}>
                  {isTopLevel ? (
                    data.name
                  ) : (
                    <MenuItemTextHighlighter
                      text={data.name}
                      highlight={searchTerm}
                    />
                  )}
                </span>
              )}
            </div>
          </Link>
        ) : (
          <a
            href={data.link}
            target={data.page_link_newtab ? "_blank" : "_self"}
            rel="noreferrer"
            data-tooltip-id={isCollapsed ? tooltipId : undefined}
            data-tooltip-content={isCollapsed ? data.name : undefined}
            data-tooltip-place="right"
            className={classNames(
              "flex min-h-10 w-full items-center rounded py-2 text-leftNavActiveTextColor underline transition-all hover:bg-leftNavActiveColor hover:text-blue-700 hover:text-leftNavActiveTextColor",
              isCollapsed ? "justify-center px-1" : "justify-between px-3",
              buttonClasses,
              data._id === page_id || data.slug === page_id ? "!bg-leftNavActiveColor text-leftNavActiveTextColor" : "text-leftNavTextColor",
            )}>
            <div className={classNames("flex min-w-0 items-center", isCollapsed ? "flex-initial justify-center" : "flex-1")}>
              {(image || isCollapsed) && (
                <div
                  className={classNames("nav-icon flex flex-shrink-0 items-center justify-center [&_svg]:h-full [&_svg]:w-full", isCollapsed ? "mr-0 h-6 w-6" : "mr-4 h-5 w-5", imageClassName)}>
                  {image ? (
                    isSVGString(image) ? (
                      <div
                        className="h-full w-full"
                        dangerouslySetInnerHTML={{ __html: image.replace(/stroke-width="[^"]*"/g, 'stroke-width="1.7"') }}
                      />
                    ) : (
                      <Image
                        src={image}
                        alt={"Menu image"}
                        classes={classNames(imageClassName, "h-full w-full object-contain")}
                        onError={() => setImageClassName("hidden")}
                      />
                    )
                  ) : (
                    <ArrowTopRightOnSquareIcon className="h-6 w-6 stroke-[1.7]" />
                  )}
                </div>
              )}

              {!isCollapsed && (
                <span
                  className={classNames("min-w-0 flex-1 break-words text-base leading-tight", isTopLevel ? "font-normal" : "font-medium")}
                  title={data.name}>
                  {" "}
                  <MenuItemTextHighlighter
                    text={data.name}
                    highlight={searchTerm}
                  />
                </span>
              )}
              {!isCollapsed && <ArrowTopRightOnSquareIcon className={classNames("ml-auto h-4 w-4 flex-shrink-0 stroke-2")} />}
            </div>
          </a>
        )}
        {isCollapsed && (
          <Tooltip
            id={tooltipId}
            place="right"
            positionStrategy="fixed"
            offset={10}
            delayShow={150}
            className="!z-[99999] !rounded-md !px-2.5 !py-1.5 !text-xs !font-medium !shadow-xl"
            style={{ backgroundColor: "#1f2937", color: "#ffffff", zIndex: 99999 }}
          />
        )}
      </div>
    </>
  );
};

export default LeftMenuItemLink;
